import _ from 'lodash';
import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';  
import {decrementPending, incrementPending, request} from '../../containers/actions';
import {push} from 'react-router-redux';
import {Checkbox} from 'rmwc';

import * as styles from '../../styles';
import Tree from '../tree';
import {refresh as paginatorRefresh, addItem, updateItem} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import Barcode from './barcode';
import EssayBarcode from './essay_barcode';
import filtersSelectorGenerator from './filters';
import ExaminationAnalysis from './examinationAnalysis';
import { host_v2 } from '../../utilities/requests';


export default class Examinations extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
        booleanProperties: [],
    }

    state = {
        barcodeExamination: undefined,
        showAnalyzepage : false,
    }

    regionsTreeSelector = createSelector(
        [() => this.state.id],
        id => ({registrations_examination: id}),
    )

    citiesTreeSelector = createSelector(
        [
            () => this.props.store.getIn(['regionsTree', 'selected']),
            () => this.state.id,
        ],
        (regions, id) => ({
            region: regions.keySeq().join(',') || -1,
            registrations_examination: id,
        }),
    )

    schoolsTreeSelector = createSelector(
        [
            () => this.props.store.getIn(['regionsTree', 'selected']), 
            () => this.props.store.getIn(['citiesTree', 'selected']),
            () => this.state.id,
        ],
        (regions, cities, id) => ({
            region: regions.keySeq().join(',') || -1,
            city: cities.keySeq().join(',') || -1,
            students__student__registrations__examination: id,
        }),
    ) 
    GotoUrl(id){ 
        var token = this.context.store.getState().get('application').get('token'); 
        var auth =token.get('accessToken');
        var url = "https://panel.mhelli.com/setmarkers?authToken="+auth+"&id="+id;
        window.open(url, '_blank');
    }

    listFieldsSelector = createSelector(
        [
            () => this.context.user,
            () => this.props.module,
        ],
        () => [
            {field: 'id', label: window.gettext('ID')},
            {
                field: item => <span>
                    {item.locked
                        ? <span><i style={{color: styles.alertColor}} className='fa-lock fa-lg'/>&nbsp;</span>
                        : null
                    }
                    {item.title}
                </span>,
                label: window.gettext('Title'),
            },
            {
                field: item => _.map(item.grades, grade => grade.title).join(window.gettext(',') + ' '),
                label: window.gettext('Grade'),
            },

            // convert and sets the filter item to jalali date when we want to filtering the all items .
            //the filtering and the quiz are true working.
            {field: item => item.date.toJalali().persian(), label: window.gettext('Date')},
            ...this.context.user.hasPerm('examination.edit_profile') && this.props.module === 'content'
                ? [
                    {
                        label: window.gettext('Ability to Layout'),
                        field: 'layout_locked',
                        inverse: true,
                    },
                    {
                        label: window.gettext('Publish Key'),
                        field: 'published_key',
                    },
                    {
                        label: window.gettext('Analyze Based on Score'),
                        field: 'analyze_model',
                        mapping: [
                            [true, 2],
                            [false, 1],
                        ],
                    },
                    {
                        label: window.gettext('Complaint'),
                        field: 'complaint',
                    },
                    {
                        label: window.gettext('Online'),
                        field: item => item.online===true || item.online===null,
                    },
                    {
                        label: window.gettext('Paper Based'),
                        field: item => item.online===false || item.online===null,
                    },
                    {
                        label: window.gettext('Restricted'),
                        field: 'restricted',
                    },
                    {
                        label: window.gettext('Supply in Store'),
                        field: 'for_sale',
                    },
                ]
                : [],
            ...this.context.user.hasPerm('examination.add_question') && this.props.module === 'content'
                ? [
                    {
                        style: {width: '1px'},
                        field: item => <button
                            style={{
                                ...styles.button,
                                backgroundColor: 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.context.store.dispatch(push(
                                    this.context.store.getState().getIn(
                                        ['routing', 'locationBeforeTransitions', 'pathname'],
                                    ) + item.id + '/questions/',
                                ));
                            }}
                            onMouseUp={({target}) => target.blur()}>
                            {window.gettext('Questions')}
                        </button>,
                        label: '',
                    },
                ]
                : [],
            // ...this.context.user.hasPerm('examination.add_question') && this.props.module === 'content'
            //     ? [
            //         {
            //             style: {width: '1px'},
            //             field: item => <button
            //                 style={{
            //                     ...styles.button,
            //                     backgroundColor: 'transparent',
            //                     padding: '.25em',
            //                     boxSizing: 'border-box',
            //                 }}
            //                 onClick={event => {
            //                     event.stopPropagation();
            //                     this.context.store.dispatch(push(
            //                         this.context.store.getState().getIn(
            //                             ['routing', 'locationBeforeTransitions', 'pathname'],
            //                         ) + item.id + '/questions/',
            //                     ));
            //                 }}
            //                 onMouseUp={({target}) => target.blur()}>
            //                 {window.gettext('انتقال عکس آزمون')}
            //             </button>,
            //             label: '',
            //         },
            //     ]
                // : [],
            ...this.context.user.hasPerm('examination.layout') && this.props.module === 'content'
                ? [
                    {
                        style: {width: '1px'},
                        field: item => <button
                            style={{
                                ...styles.button,
                                backgroundColor: 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.context.store.dispatch(push(
                                    this.context.store.getState().getIn(
                                        ['routing', 'locationBeforeTransitions', 'pathname'],
                                    ) + item.id + '/layout/',
                                ));
                            }}
                            onMouseUp={({target}) => target.blur()}>
                            {window.gettext('Layout')}
                        </button>,
                        label: '',
                    },
                ]
                : [],
            ...this.context.user.hasPerm('examination.print') && this.props.module === 'content'
                ? [
                    {
                        style: {width: '1px'},
                        field: item => <button
                            style={{
                                ...styles.button,
                                backgroundColor: 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.setState({barcodeExamination: item});
                            }}
                            onMouseUp={({target}) => target.blur()}>
                            {window.gettext('Barcodes')}
                        </button>,
                        label: '',
                    },
                ]
                : [],
            ...this.context.user.hasPerm('examination.set_markers') && this.props.module === 'analyze'
                ? [
                    {
                        style: {width: '1px'},
                        field: item => item.type === 2
                            ? 
                            // <a
                            // href={"https://panel.mhelli.com/setmarkers?authToken="+this.state.token+"&id="+item.id}
                            //     style={{
                            //         ...styles.button,
                            //         backgroundColor: 'transparent',
                            //         padding: '.25em',
                            //         boxSizing: 'border-box',
                            //         textDecoration:'none'
                            //     }}>
                            //     {window.gettext('Markers')}
                            // </a>
                            <button
                            style={{
                                        ...styles.button,
                                        backgroundColor: 'transparent',
                                        padding: '.25em',
                                        boxSizing: 'border-box',
                                        textDecoration:'none'
                                    }}
                                    onClick={event => {
                                        event.stopPropagation();
                                        this.GotoUrl(item.id);
                                    }}
                                    onMouseUp={({target}) => target.blur()}>
                                    {window.gettext('Markers')}
                            </button>
                            
                            : null,
                        label: '',
                    },
                ]
                : [],
            ...this.context.user.hasPerm('examination.analyze') && this.props.module === 'analyze'
                ? [
                    {field: 'registered', label: window.gettext('Registered')},
                    {field: 'read_papers', label: window.gettext('Read Papers')},
                    {
                        field: item => <div
                            style={{
                                backgroundColor: item.base_analyze === item.read_papers
                                    ? styles.successBackColor
                                    : item.base_analyze === 0
                                        ? styles.warningBackColor
                                        : undefined,
                                color: item.base_analyze === item.read_papers
                                    ? styles.successColor
                                    : item.base_analyze === 0
                                        ? styles.warningColor
                                        : undefined,
                                borderColor: item.base_analyze === item.read_papers
                                    ? styles.successBorderColor
                                    : item.base_analyze === 0
                                        ? styles.warningBorderColor
                                        : undefined,
                                textAlign: 'center',
                            }}>
                            {item.read_papers === 0
                                ? ''
                                : item.base_analyze === item.read_papers
                                    ? window.gettext('Base Analyze') 
                                    : item.base_analyze === 0
                                        ? window.gettext('Second Analyze')
                                        : <span>
                                            <span
                                                style={{
                                                    backgroundColor: styles.successBackColor,
                                                    color: styles.successColor,
                                                    borderColor: styles.successBorderColor,
                                                    padding: '.5em',
                                                }}>
                                                {item.base_analyze.persian()}
                                            </span>
                                            &nbsp;-&nbsp;
                                            <span
                                                style={{
                                                    backgroundColor: styles.warningBackColor,
                                                    color: styles.warningColor,
                                                    borderColor: styles.warningBorderColor,
                                                    padding: '.5em',
                                                }}>
                                                {(item.read_papers - item.base_analyze).persian()}
                                            </span>
                                        </span>
                            }
                        </div>,
                        label: window.gettext('Base Analyze'),
                    },
                    {
                        style: {width: '1px'},
                        field: item => <button
                            disabled={item.processing.length > 0 || !item.unprocessed}
                            style={{
                                ...styles.button,
                                backgroundColor: item.error ? styles.alertBackColor : 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                                position: 'relative',
                                color: item.processing.length > 0 || !item.unprocessed ?
                                    '#9a9a9a' :
                                    item.error ? styles.alertColor : styles.button.color,
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.context.store.dispatch(request({
                                    path: `/examination/${item.id}/clean_analyze/`,
                                    method: 'POST',
                                }));
                                this.context.store.dispatch(updateItem(
                                    {...item, processing: 'clean_analyze'},
                                    this.props.store.getIn(['paginator', 'elementId']),
                                ));
                            }}
                            onMouseUp={({target}) => target.blur()}>
                            {window.gettext('Clean Analyze')}
                            {item.processing.replace(/^_/, '') === 'clean_analyze'
                                ? <div style={{position: 'absolute', top: '0', left: '0', width: '100%', height: '100%'}}>
                                    <i className={`fa-spin fa-${item.processing.startsWith('_') ? 'cog' : 'spinner'} fa-2x`}></i>
                                </div>
                                : null
                            }
                        </button>,
                        label: '',
                    },
                    {
                        style: {width: '1px'},
                        field: item => <button
                            disabled={item.processing.length > 0}
                            style={{
                                ...styles.button,
                                backgroundColor: item.error ? styles.alertBackColor : 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                                position: 'relative',
                                color: item.processing.length > 0 ? '#9a9a9a' : item.error ? styles.alertColor : styles.button.color,
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.context.store.dispatch(request({
                                    path: `/examination/${item.id}/re_analyze/`,
                                    method: 'POST',
                                }));
                                this.context.store.dispatch(updateItem(
                                    {...item, processing: 're_analyze'},
                                    this.props.store.getIn(['paginator', 'elementId']),
                                ));
                            }}
                            onMouseUp={({target}) => target.blur()}>
                            {window.gettext('Divided Analyze')}
                            {item.processing.replace(/^_/, '') === 're_analyze'
                                ? <div style={{position: 'absolute', top: '0', left: '0', width: '100%', height: '100%'}}>
                                    <i className={`fa-spin fa-${item.processing.startsWith('_') ? 'cog' : 'spinner'} fa-2x`}></i>
                                </div>
                                : null
                            }
                            
                        </button>,
                        label: '',
                    },
                    {
                        style: {width: '1px'},
                        field: item => <button
                            disabled={item.processing.length > 0}
                            style={{
                                ...styles.button,
                                backgroundColor: item.error ? styles.alertBackColor : 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                                position: 'relative',
                                color: item.processing.length > 0 ? '#9a9a9a' : item.error ? styles.alertColor : styles.button.color,
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.context.store.dispatch(request({
                                    path: `/examination/${item.id}/analyze_remaining/`,
                                    method: 'POST',
                                }));
                                this.context.store.dispatch(updateItem(
                                    {...item, processing: 'analyze_remaining'},
                                    this.props.store.getIn(['paginator', 'elementId']),
                                ));
                            }}  
                            onMouseUp={({target}) => target.blur()}>
                            {window.gettext('Analyze Remaining')}
                            {item.processing.replace(/^_/, '') === 'analyze_remaining'
                                ? <div style={{position: 'absolute', top: '0', left: '0', width: '100%', height: '100%'}}>
                                    <i className={`fa-spin fa-${item.processing.startsWith('_') ? 'cog' : 'spinner'} fa-2x`}></i>
                                </div>
                                : null
                            }
                        </button>,
                        label: '',
                    },
                    {
                        style: {width: '1px'},
                        field: item => <button
                            disabled={item.processing.length > 0}
                            style={{
                                ...styles.button,
                                backgroundColor: item.error ? styles.alertBackColor : 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                                position: 'relative',
                                color: item.processing.length > 0 ? '#9a9a9a' : item.error ? styles.alertColor : styles.button.color,
                            }}
                            onClick={event => {
                                event.stopPropagation();
                                this.context.store.dispatch(request({
                                    path: `/examination/${item.id}/process_papers/`,
                                    method: 'POST',
                                }));
                                this.context.store.dispatch(updateItem(
                                    {...item, processing: 'process_papers'},
                                    this.props.store.getIn(['paginator', 'elementId']),
                                ));
                                console.log()
                                //window.print();
                            }}
                            onMouseUp={({target}) => target.blur()}
                            >
                            {window.gettext('Read')}
                            {item.processing.replace(/^_/, '') === 'process_papers'
                                ? <div style={{position: 'absolute', top: '0', left: '0', width: '100%', height: '100%'}}>
                                    <i className={`fa-spin fa-${item.processing.startsWith('_') ? 'cog' : 'spinner'} fa-2x`}></i>
                                </div>
                                : null
                            }
                        </button>,
                        label: '',
                    },
                    {
                        style: {width: '1px'},
                        field: item => (item.examination_type?.id == 6 || item.examination_type?.id == 7) && <button
                            // disabled={}
                            style={{
                                ...styles.button,
                                backgroundColor: item.error ? styles.alertBackColor : 'transparent',
                                padding: '.25em',
                                boxSizing: 'border-box',
                                position: 'relative',
                                color: this.state.btnPreLoader ? '#9a9a9a' : styles.button.color,
                            }}
                            onClick={async (event) => {
                                this.setState({btnPreLoader:true})
                                event.stopPropagation();
                                this.context.store.dispatch(incrementPending())
                                var token = this.context.store.getState().get('application').get('token');
                                var auth = token.get('accessToken');
                                const url = `${host_v2}/api/NewShabihSazReportApi/StartAnalyze`;
                                const res = await fetch(url ,{
                                    method: 'POST',
                                    body: JSON.stringify({examId:item.id}),
                                    headers: {
                                        Authorization: 'Bearer ' + auth,
                                        'Content-Type': 'application/json'
                                    },
                                }
                                );
                                const data = await res.json()
                                this.context.store.dispatch(decrementPending())
                                alert(data.result)
                            }}
                            onMouseUp={({target}) => target.blur()}>
                            {window.gettext("shabihsaz Analyze")}
                        </button>,
                        label: '',
                    },
                ]
                : [],
        ],
    );

    filtersSelector = filtersSelectorGenerator.bind(this)()

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'date', label: window.gettext('Date')},
        {name: 'title', label: window.gettext('Title')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.module,
            () => this.props.store.getIn(['paginator', 'selected']).size,
        ],
        () => this.props.readonly || this.props.module !== 'content'
            ? this.props.actions
            : _.concat(this.props.actions, this.props.store.getIn(['paginator', 'selected']).size
                ? []
                : [],
            ),
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.buttonActions,
            () => this.props.readonly,
        ],
        () => this.props.readonly || this.props.module !== 'content'
            ? this.props.buttonActions
            : _.concat(this.props.buttonActions, [
                {
                    label: window.gettext('New Examination'),
                    action: this.newExamination.bind(this),
                },
                {
                    label: window.gettext('انتقال عکس آزمون ها'),
                    action: this.GoToUrlTransferExamsImage.bind(this)
                },
            ]),
    )

    

    booleanPropertiesSelector = createSelector(
        [
            () => this.props.booleanProperties,
            () => this.props.readonly,
            () => this.props.module,
        ],
        () => this.props.readonly || this.props.module !== 'content'
            ? this.props.buttonActions
            : _.concat(this.props.booleanProperties, [
                {
                    label: window.gettext('Ability to Layout'),
                    field: 'layout_locked',
                    inverse: true,
                },
                {
                    label: window.gettext('Publish Key'),
                    field: 'published_key',
                },
                {
                    label: window.gettext('Analyze Based on Score'),
                    field: 'analyze_model',
                    mapping: [
                        [true, 2],
                        [false, 1],
                    ],
                },
                {
                    label: window.gettext('Complaint'),
                    field: 'complaint',
                },
                {
                    label: window.gettext('Online'),
                    field: 'online',
                },
                {
                    label: window.gettext('Restricted'),
                    field: 'restricted',
                },
                {
                    label: window.gettext('Supply in Store'),
                    field: 'for_sale',
                },
            ]),
    ) 
 
    constructor(props) {
        super(props);
        this.tooltip = this.tooltip.bind(this);
        this.citiesTreeItemLabel = this.citiesTreeItemLabel.bind(this);
        this.schoolsTreeItemLabel = this.schoolsTreeItemLabel.bind(this);
    }
    componentDidMount(){
        // console.log("aaaathis.props.store is:",this.props.store);
    }
    componentDidUpdate(prevProps) {
        // debugger;
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }  
 
    tooltip(item) {
        return (item.note || '').persian();
    }

    citiesTreeItemLabel(city) {
        return `${city.region_display} - ${city.name}`;
    }

    schoolsTreeItemLabel(school) {
        return `${school.city.name} - ${school.name} -` +
            ` ${_.map(school.levels, level => level.title).join(window.gettext(','))}`;
    }

    async newExamination() {
        const title = prompt(window.gettext('Title') + ':');
        if (!title)
            return;
        const response = await this.context.store.dispatch(request({
            path: '/examination/',
            body: {title},
            method: 'POST',
        }));
        this.context.store.dispatch(addItem(
            response,
            this.props.store.getIn(['paginator', 'pageSize']),
            this.props.store.getIn(['paginator', 'elementId']),
        ));
    }

    async GoToUrlTransferExamsImage() {
        var token = this.context.store.getState().get('application').get('token'); 
        var auth =token.get('accessToken');
        var url = host_v2 + "/Exams?pageId=1";
        window.open(url, '_blank') ;
    } 
    
    events = {
        onClick: item => {
            // debugger;
            if (this.context.user.hasPerm('examination.reports') && this.props.module === 'analyze') {
                this.context.store.dispatch(push(
                    `/reports/multiple-choice/${item.id}/report/`,
                ));
            }
            else if (this.context.user.hasPerm('examination.edit_profile') && this.props.module === 'content') {
                this.context.store.dispatch(push(
                    this.context.store.getState().getIn(
                        ['routing', 'locationBeforeTransitions', 'pathname'],
                    ) + item.id + '/info/',
                ));
            }
        },
    }

    render() {
        return <span>
            <span style={{display: this.props.children || this.state.barcodeExamination ? 'none' : undefined}}>
                {this.state.showAnalyzepage
                 ? <ExaminationAnalysis
                    handleShowAnalyzePage={()=>{this.setState({showAnalyzepage : !this.state.showAnalyzepage })}}
                  /> :
                    <PaginatedContainer
                    store={this.props.store.get('paginator')}
                    handleShowAnalyzePage={()=>{this.setState({showAnalyzepage : !this.state.showAnalyzepage })}}
                    resource='examination'
                    listFields={this.listFieldsSelector(this.props.store)}
                    title={window.gettext('Examinations Bank')+''}
                    selectable
                    events={this.events}
                    filters={this.filtersSelector(this.props.store)}
                    sorts={this.sorts}
                    pageSize={this.props.pageSize}
                    actions={this.actionsSelector(this.props.store)}
                    buttonActions={this.buttonActionsSelector(this.props.store)}
                    booleanProperties={this.booleanPropertiesSelector(this.props.store)}
                    />
                }
            </span>
            {this.props.children}
            {this.state.barcodeExamination
                ? <div
                    style={{
                        width: '100%',
                        float: 'right',
                        marginLeft: '1em',
                        marginTop: '.5em',
                    }}>
                    <div style={{float: 'right', width: '50%'}}>
                        <div key='region' style={{...treeStyle, width: 'calc(50% - 1em)'}}>
                            <Tree
                                store={this.props.store.get('regionsTree')}
                                readonly
                                resource='region'
                                itemLabel='name'
                                multiSelection={false}
                                combobox
                                label={window.gettext('Region')}
                                filter={this.regionsTreeSelector(this.state.barcodeExamination.id)}
                            />
                        </div>
                        <div key='city' style={{...treeStyle, width: 'calc(50% - 1em)'}}>
                            <Tree
                                store={this.props.store.get('citiesTree')}
                                readonly
                                resource='city'
                                itemLabel={this.citiesTreeItemLabel}
                                multiSelection={false}
                                combobox
                                label={window.gettext('City')}
                                filter={this.citiesTreeSelector({
                                    regionsTree: this.props.store.getIn(['regionsTree', 'selected']),
                                    id: this.state.barcodeExamination.id,
                                })}
                            />
                        </div>
                        <div key='school' style={{...treeStyle, width: 'calc(100% - 1em)', clear: 'right'}}>
                            <Tree
                                store={this.props.store.get('schoolsTree')}
                                readonly
                                resource='school'
                                itemLabel={this.schoolsTreeItemLabel}
                                multiSelection
                                combobox={false}
                                label={window.gettext('School')}
                                filter={this.schoolsTreeSelector({
                                    regionsTree: this.props.store.getIn(['regionsTree', 'selected']),
                                    citiesTree: this.props.store.getIn(['citiesTree', 'selected']),
                                    id: this.state.barcodeExamination.id,
                                })}
                            />
                        </div>
                    </div>
                    <iframe
                        ref='barcode'
                        style={{width: '0', height: '0', border: 'none'}}

                        // style={{width: '100%', height: '400px', border: 'none'}}
                        
                        srcDoc={`<html>
    <head>
        <link rel="stylesheet" type="text/css" href="/css/mhelli.css">
        <link rel="stylesheet" type="text/css" href="/css/mathjax.css">
        <style>
            @page {
                size: ${this.state.barcodeExamination.paper_type === 15 ? 'A5' : 'A4'} Portrait;
                margin: 0;
            }
            html, body {
                font-family: IRANSans;
                font-size: 9pt;
                margin: 0;
                width : 148mm;
                height : 100mm;
                size: auto;
                direction: rtl;
            }
            @media print {
                div {
                    -webkit-print-color-adjust: exact;
                }
            }
        </style>
        <script src="/mathjax/MathJax.js?delayStartupUntil=configured"></script>
    </head>
    <body>
        <span id='barcode'><span>1</span><span style='font-weight: 700;'>2</span></span>
        <script type='text/javascript'>
            MathJax.Hub.Config({
                config: ['MMLorHTML.js'],
                jax: ['input/TeX','input/MathML','input/AsciiMath','output/HTML-CSS','output/NativeMML', 'output/PreviewHTML'],
                extensions: ['tex2jax.js','mml2jax.js','asciimath2jax.js', 'fast-preview.js', 'AssistiveMML.js'],
                TeX: {
                    extensions: [
                        'AMSmath.js',
                        'AMSsymbols.js',
                        'AMScd.js',
                        'noErrors.js',
                        'noUndefined.js',
                        'cancel.js',
                        'mhchem.js',
                        'autobold.js',
                    ],
                },
                'HTML-CSS': {
                    mtextFontInherit: true,
                },
                messageStyle: 'none',
                menuSettings: {
                    inTabOrder: false,
                    context: 'Browser',
                },
                processSectionDelay: 0,
                skipStartupTypeset: true,
            });
            MathJax.Hub.Configured();
        </script>
    </body>
</html>`}
                    />
                    <div style={{float: 'left', marginRight: '.5em'}}>
                        <button
                            style={{...styles.button, float: 'left', marginRight: '.5em'}}
                            onClick={() => this.setState({barcodeExamination: undefined})}>
                            {window.gettext('Back')}
                        </button>
                        <button
                            style={{
                                ...styles.defaultButton,
                                backgroundColor: styles.fourthColor,
                                float: 'left',
                                marginRight: '.5em',
                            }}
                            onClick={async () => {
                                const response = await this.context.store.dispatch(
                                    request(
                                        '/registration/?school=' +
                                        this.props.store.getIn(['schoolsTree', 'selected']).keySeq().join(',') + '&examination=' +
                                        this.state.barcodeExamination.id + '&limit=100000',
                                    ),
                                );
                                const data = response.results; 
                                if (data.length === 0) {
                                    alert(window.gettext('No student is registered for these examinations.'));
                                    return;
                                }                            
                                const win = this.refs.barcode.contentWindow;
                                ReactDom.unmountComponentAtNode(win.document.getElementById('barcode'));
                                ReactDom.render(<span>
                                    {_.map(
                                        _.sortBy(data, ['student.clazz.id', 'student.lastname', 'student.firstname']),
                                        row => 
                                        row.online===false?
                                            (this.state.barcodeExamination.type === 1
                                                ?<Barcode
                                                 qrcode
                                                 background={this.state.background}
                                                 key={row.id}
                                                 {...row}
                                                 examination={this.state.barcodeExamination}
                                             />
                                             : <EssayBarcode
                                                 key={row.id}
                                                 {...row}
                                                //  layout={this.props.store.get('layout').toJS()}
                                                 examination={this.state.barcodeExamination}  
                                             />) :  null 
                                        
                                        ,
                                    )
                                    }
                                </span>, win.document.getElementById('barcode'));
                                win.print();
                            }}>
                            {window.gettext('Generate Barcodes')}
                        </button>
                        <div>
                            <Checkbox
                                key='background'
                                checked={this.state.background}
                                onChange={() => this.setState({background: !this.state.background})}>
                                {window.gettext('Background')}
                            </Checkbox>
                        </div>
                    </div>
                </div>
                : null
            }
        </span>;
    }
}

const treeStyle = {
    fontSize: '.8em',
    width: 'calc(100%/6 - 1em)',
    marginBottom: '1em',
    marginLeft: '.5em',
    marginRight: '.5em',
    float: 'right',
    maxHeight: '25em',
};
